/* eslint no-param-reassign: ["error", { "props": false }] */
import set from 'lodash/set';
import { datadogRum } from '@datadog/browser-rum';

const onError = (error, opts = {}) => {
  if (error.ignoreIfHandled) {
    return;
  }

  if (process.env.NODE_ENV === 'development') {
    console.error(error); // eslint-disable-line no-console
  }

  if (error.name === 'BraintreeError') {
    set(opts, 'metaData.braintreeError', {
      details: error.details,
      code: error.code,
      message: error.message,
      type: error.type,
    });
  }

  datadogRum.addError(error, opts);
};

export default onError;
